/**
 * @generated SignedSource<<2bcf18aa0a322a7ad1a58b91b24cdd2b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsHeroStatus_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatusContact_viewer">;
  readonly " $fragmentType": "TradeBenefitsHeroStatus_viewer";
};
export type TradeBenefitsHeroStatus_viewer$key = {
  readonly " $data"?: TradeBenefitsHeroStatus_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatus_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsHeroStatus_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsHeroStatusContact_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "99a57e1019f50115d3754e565c95b3bc";

export default node;
